import LazyLoad from 'vanilla-lazyload'

export default (new LazyLoad({elements_selector: 'img[data-src], video[data-src]'}))
